export default "__VITE_ASSET__CfifvBlB__"